import { useCallback } from 'react';
import { useStore } from 'react-redux';

import useRequest from '@swf/core/hooks/useRequest';
import type { RootState } from '@swf/core/store';
import buildSportsRequest from '@swf/sports/utils/buildSportsRequest';

import type { CashoutBetRequest, CashoutBetResponse } from '../types';

const useRequestCashOut = () => {
  const { getState } = useStore<RootState>();
  const request = useRequest();
  const boundRequest = useCallback((options) => request(options).toPromise(), [request]);
  const sportsRequest = buildSportsRequest(boundRequest, getState());

  const cashOutRequest = useCallback(
    (body: CashoutBetRequest) =>
      sportsRequest<CashoutBetResponse>({
        path: '/gbp/sco/api/sports/fixedodds/transactional/v1.0/cashoutBet',
        method: 'POST',
        body
      }),
    [sportsRequest]
  );

  return cashOutRequest;
};

export default useRequestCashOut;
